export default __webpack_public_path__ + "static/media/ic_ahu_energy.a62ec228.svg";